export default "__VITE_ASSET__CevO0Izf__"